import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles({
  paper: {
    zIndex: 'auto'
  },
  searchBar: {
    padding: '20px 24px',
    boxShadow: palette.shadows.light,
    background: palette.gradients.white,
    display: 'flex',
    marginTop: '32px',
    marginBottom: '10px',
    [breakpointsFunc.breakpoints.down('md')]: {
      flexWrap: 'wrap'
    }
  },
  selector: {
    flexGrow: '1',
    marginRight: '10px',
    [breakpointsFunc.breakpoints.down('md')]: {
      width: '100%',
      marginRight: '0'
    }
  },
  chargesRangeDatePicker: {
    width: '200px',
    '& + &': {
      marginLeft: '10px'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      width: 'calc(50% - 5px)',
      marginTop: '20px',
      marginLeft: '0'
    }
  }
});
export default useStyles;